import firebase from 'firebase';

export class FirebaseService {

    config= {
        apiKey: "AIzaSyC1b_NF7TK0Q3PfsPyBj7qsVcQHwruNvhw",
        authDomain: "fitpass-1518561696471.firebaseapp.com",
        databaseURL: "https://fitpass-1518561696471.firebaseio.com",
        projectId: "fitpass-1518561696471",
        storageBucket: "fitpass-1518561696471.appspot.com",
        messagingSenderId: "693804970292"
    };

    webPushCertificate ="BGL9-PI-Cr66H-tHL8rx-NrDiRVQ2BRbIENygvOcvwjn3cDlT4mRH_iCK5CVpKMbR1kOs4rPPd6-Shj76mwmNzw";

    initializeFirebase(){
        firebase.initializeApp(this.config);
        if(firebase.messaging.isSupported()){
          firebase.messaging().usePublicVapidKey(this.webPushCertificate);
        }
    }

}



// WEBPACK FOOTER //
// ./src/services/firebase.ts